<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'IMAGE_TYPES', url: '/admin/image-types' },
    { label: 'UPDATE_IMAGE_TYPE' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_IMAGE_TYPE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">{{
        'NAME' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="TITLE">{{
        'TITLE' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          name="title"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['title'])"
          [ngClass]="{ 'is-danger': hasError('title') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('title')">
        {{ getError('title') }}
      </p>
    </div>

    <div class="field is-narrow mb-5">
      <label class="label mb-0" translationEditableDirective="FOR">{{
        'FOR' | translate
      }}</label>
      <div class="control" style="margin-top: -10px">
        <radio
          [options]="radioOptions"
          [controlled]="true"
          name="for"
          [value]="for"
          (onChange)="handleFieldChange($event, 'for')"
        ></radio>
      </div>
      <p class="help is-danger" *ngIf="hasError('for')">
        {{ getError('for') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/image-types']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
